import axiosIns from '@/api/axios';
export const GET_DASHBORD = (payload) => {
	return axiosIns.get(`/dashboard?${payload}`);
};
